module.exports = __webpack_public_path__ + "img/NoBills.81d47b2d.png";